/**
 * Generic model to support API
 */

import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  namedAttributes: {
    data: Object,
    meta: Object,
  },
  defaults: {
    data: [],
    meta: {},
  },
});

export { Model as default };
